import { Breadcrumb } from "reactstrap";
import styled from "styled-components";

const StyledBreadcrumb = styled(Breadcrumb)`
  margin-top: 0.75rem;
  > * {
    padding: 0;
    margin: 0;
    background-color: transparent;
  }
`;

const LinkContainer = ({ children }) => {
  return <StyledBreadcrumb listTag="div">{children}</StyledBreadcrumb>;
};

export default LinkContainer;
